"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Tab_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/Tab"));
const BackButton_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/BackButton.vue"));
const Loader_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Loader.vue"));
const Tabs_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/UI/Tabs.vue"));
const BoxPlot_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BoxPlot.vue"));
const trans_1 = require("@common/tsutils/trans");
let DensityTool = class DensityTool extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.list_types = [
            { type: 'genus', label: (0, trans_1.trans)('mwm.genus') },
            { type: 'species', label: (0, trans_1.trans)('mwm.species') },
        ];
        this.list_type = 'genus';
        this.selected_genus = this.genus[0];
        this.selected_org = this.orgs[0];
        this.plots = null;
        this.mode = 'custom%';
        this.fetching = false;
        this.options = [
            new Tab_1.default({
                'mode': '100%',
                "name": (0, trans_1.trans)('toolkit.abun_boxplot.domain.standard').concat(' 0-100%'),
                "active": false
            }),
            new Tab_1.default({
                'mode': 'custom%',
                "name": (0, trans_1.trans)('toolkit.abun_boxplot.domain.custom'),
                "active": true
            }),
        ];
    }
    get totalSamples() {
        if (!this.plots)
            return 0;
        return this.plots.reduce(function (prev, curr) {
            return prev + curr.cluster.samples.length;
        }, 0);
    }
    get totalParcels() {
        if (!this.plots)
            return 0;
        const parcels = {};
        this.plots.forEach(p => p.cluster.samples.forEach(s => {
            if (!s.parcel)
                return;
            parcels[s.parcel.id] = true;
        }));
        return Object.keys(parcels).length;
    }
    toClusterEdition() {
        this.$emit('to-cluster');
    }
    onSwitchTab(i) {
        this.options.forEach((tab) => tab.active = false);
        this.options[i].active = true;
        this.mode = this.options[i].mode;
    }
    onChangeListType() {
        if (this.list_type === 'genus') {
            this.onChangeGenus();
        }
        else {
            this.onChangeMwm();
        }
    }
    async onChangeGenus() {
        if (this.list_type !== 'genus')
            return;
        this.fetching = true;
        const plots = await this.density.compare_genus(this.selected_genus);
        this.plots = plots.reverse();
        this.fetching = false;
    }
    async onChangeMwm() {
        if (this.list_type !== 'species')
            return;
        this.fetching = true;
        const plots = await this.density.compare_species(this.selected_org);
        this.plots = plots.reverse();
        this.fetching = false;
    }
    mounted() {
        this.onChangeGenus();
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], DensityTool.prototype, "density", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], DensityTool.prototype, "genus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)()
], DensityTool.prototype, "orgs", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('list_type')
], DensityTool.prototype, "onChangeListType", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('selected_genus')
], DensityTool.prototype, "onChangeGenus", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('selected_org')
], DensityTool.prototype, "onChangeMwm", null);
DensityTool = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            BackButton: BackButton_vue_1.default,
            Loader: Loader_vue_1.default,
            Tabs: Tabs_vue_1.default,
            BoxPlot: BoxPlot_vue_1.default
        }
    })
], DensityTool);
exports.default = DensityTool;
